import React from "react";
import { Row } from "react-bootstrap";
import { connect } from "react-redux";
import { ActivityLogs } from "../../activityLogs";
import { GetActivityLogs } from "../action";
import { DataType } from "constant";

import moment from "moment";

import { ConfigurationPath } from "routes/paths";

const ConfigurationActivityLogFilters = Object.freeze([
  {
    key: "ConfigName",
    value: "Config Name",
    isDefault: true,
    dataType: DataType.String,
  },
  { key: "UserId", value: "User", dataType: DataType.String },
]);

const ConfigurationsActivityLogs = ({ GetActivityLogs, history }) => {
  return (
    <div className="container-fluid">
      <h1>Configurations</h1>
      <Row>
        <ActivityLogs
          hasActivityFilter
          onFetchActivityLogs={GetActivityLogs}
          onBackMainPage={() => history.push(ConfigurationPath)}
          activityLogFilters={ConfigurationActivityLogFilters}
          backButtonLabel={"View Configuration"}
          extraColumns={[
            {
              dataField: "configurationName",
              text: "Config Name",
              sort: true,
              style: { wordWrap: "break-word" },
              headerStyle: { wordWrap: "break-word" },
              title: (cell) => cell,
            },
          ]}
          extraSortColumns={{
            configurationName: 1,
          }}
          detailsModalHeader={[
            {
              label: "Config Name",
              value: "configurationName",
            },
            {
              label: "Activity",
              value: "activity",
            },
            {
              label: "User",
              value: "user",
            },
            {
              label: "Date",
              value: "date",
              formatter: (data) => moment(data).format("LLL"),
            },
          ]}
        />
      </Row>
    </div>
  );
};

export default connect(() => {}, { GetActivityLogs })(
  ConfigurationsActivityLogs
);
